import { OfficeButton, PDFRenderer, Show, TextInput } from "components";
import config from "config";
import { useFormik } from "formik";
import { Info } from "lucide-react";
import { wrapClick } from "utils";
import * as Yup from "yup";

type Props = {};

const initialValues = {
  from: "",
};

const validationSchema = Yup.object().shape({
  from: Yup.string().required("From date is required"),
});

const AgingAnalysis = (props: Props) => {
  const form = useFormik<any>({
    initialValues,
    validationSchema,
    onSubmit: async () => {
      form.setFormikState((state) => ({ ...state, status: "SUBMITTED" }));
      form.setSubmitting(false);
      return;
    },
  });

  return (
    <div className="w-full">
      <div className="py-3 flex justify-between">
        <div>
          <h1 className="font-bold text-primary text-lg">Aging Analysis</h1>
        </div>
        <div className="flex items-center space-x-2">
          <OfficeButton
            disabled={form.isSubmitting}
            onClick={wrapClick(form.handleSubmit)}
          >
            {form.isSubmitting ? "Generating ..." : "Generate Report"}
          </OfficeButton>
        </div>
      </div>
      <form className="space-y-6 divide-y shadow-sm rounded-md bg-white p-6 divide-gray-200">
        <div className="bg-red-50 text-red-800 p-3 text-xs rounded my-5 flex justify-start gap-3 items-center">
          <Info className="h-4 w-4" />
          <p>
            Note: Aging analysis will be based on all CLOSED business and
            cedants in the system that has remained UNPAID or PARTPAYMENT.
            Please note this might take some time to generate.
          </p>
        </div>

        <div className="pt-6">
          <span className="text-xs font-light">Query Date</span>
          <div className="">
            <div>
              <TextInput
                id="from"
                label={"Reporting Date"}
                type="date"
                placeholder=""
                required={true}
                {...form}
              />
            </div>
          </div>
        </div>
      </form>

      <Show if={Boolean(form.status === "SUBMITTED" && form.isValid)}>
        <PDFRenderer
          url={`${config.asset.uri}aging-analysis-report/${btoa(
            JSON.stringify({
              date_of_reporting: form?.values?.from,
            })
          )}`}
        />
      </Show>
    </div>
  );
};

export default AgingAnalysis;
